import LinkedIn from '../icons/contact/LinkedIn.svg';
import GitHub from '../icons/contact/GitHub.svg';

const Config = {
    "pageContent":  
        {
            "pageTitle": {
                "titleLight": "get into",
                "titleHeavy": "contact"
            },
            "pageBody": [{
                "title": "LinkedIn",
                "link": "https://www.linkedin.com/in/kylejohnston1999",
                "body":  "Feel free to reach out to me on LinkedIn!",
                "icon": LinkedIn
            },
            {
                "title": "GitHub",
                "link": "https://github.com/KyleJohnston1999",
                "body":  "It ain't much, but it's honest work",
                "icon": GitHub
            }
            
            ],
            "reverse": false
        }
}

export default Config;